import { admin, type AdminOpsReportRow } from '../../lib/api';
import { useApi } from '../../hooks/useApi';
import { DataTable, type Column } from '../../components/ui';
import { useAdminT } from './adminI18n';

export default function AdminOpsReportPage() {
  const t = useAdminT();
  const q = useApi(() => admin.opsReport(12), []);
  const rows = q.status === 'success' ? q.data.rows : [];

  const columns: Column<AdminOpsReportRow>[] = [
    { key: 'month', header: t('ops.month'), mono: true, render: (r) => r.month },
    { key: 'jobs_total', header: t('ops.jobsTotal'), align: 'right', mono: true, render: (r) => String(r.jobs_total) },
    { key: 'jobs_succeeded', header: t('ops.succeeded'), align: 'right', mono: true, render: (r) => String(r.jobs_succeeded) },
    { key: 'jobs_failed', header: t('ops.failed'), align: 'right', mono: true, render: (r) => String(r.jobs_failed) },
    { key: 'cost_usd', header: t('ops.cost'), align: 'right', mono: true, render: (r) => `$${r.cost_usd.toFixed(2)}` },
  ];

  return (
    <div className="admin-page">
      <header className="admin-page__head">
        <h1>{t('ops.title')}</h1>
        <p className="admin-page__sub">{t('ops.subtitle')}</p>
      </header>
      <DataTable columns={columns} rows={rows} rowKey={(r) => r.month}
        loading={q.status === 'loading'} empty={t('emptyGeneric')} />
    </div>
  );
}
